import { Box } from 'components/Box';
import { Byline } from 'components/Byline';
import { BodySmall } from 'components/Text/BodySmall';
import { CmsApiAuthor } from 'modules/cms/api/types/CmsApiAuthor';
import { colors, gutterWidth } from 'theme/theme';

type Props = {
  fullWidthLayout?: boolean;
  author: CmsApiAuthor;
  homePageUrl: string;
  postedDate: string;
  showDate: boolean;
};

export function AuthorCard({
  fullWidthLayout,
  author,
  homePageUrl,
  postedDate,
  showDate,
}: Props) {
  return (
    <Box
      bg={colors.backgroundGrey}
      data-qa-id="author-card"
      display="flex"
      flexDirection={['column', null, null, 'row']}
      textAlign={[fullWidthLayout ? 'center' : 'left', null, null, 'left']}
      alignItems={[
        fullWidthLayout ? 'center' : 'flex-start',
        null,
        null,
        'flex-start',
      ]}
      mb="70px"
      p={[gutterWidth / 2, null, null, gutterWidth]}
      borderRadius={[16, null, null, 32]}
    >
      <Byline
        slug={author.slug}
        name={author.name}
        image={author.image || undefined}
        homePageUrl={homePageUrl}
        postedDate={postedDate}
        showDate={showDate}
      />
      <Box flex="3" mt={[3, null, null, 0]}>
        <BodySmall
          color={colors.lightContentGrey}
          dangerouslySetInnerHTML={{
            __html: author.description,
          }}
          data-qa-id="author-card-description"
        />
      </Box>
    </Box>
  );
}
